<template>
  <div>
    <div
      class="relative flex justify-start items-center group text-md"
      @click="onClick"
    >
      <input
        type="checkbox"
        class="absolute left-1/2 -translate-x-1/2 w-full h-full peer appearance-none rounded-md cursor-pointer"
        :value="value"
        :disabled="disabled"
      />
      <span
        class="w-8 h-5 flex items-center flex-shrink-0 mr-4 p-1 bg-gray-300 rounded-full duration-300 ease-in-out after:w-4 after:h-4 after:bg-white after:rounded-full after:shadow-md after:duration-300 dark:bg-gray-600"
        :class="{
          'after:translate-x-2 bg-green-400': value,
          '!bg-gray-200 dark:!bg-gray-500': disabled,
        }"
      />
      <label :class="{ 'text-error': failed }">
        <slot>{{ label }}</slot>
      </label>
    </div>
    <p v-if="failed" class="text-sm text-error">
      {{ errorMessage }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: "",
    },
    value: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    validationState: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  computed: {
    errorMessage() {
      return this.validationState?.$errors?.[0]?.$message;
    },
    failed() {
      return this.validationState?.$error;
    },
  },
  methods: {
    onClick() {
      if (this.disabled) {
        return;
      }
      this.$emit("input", !this.value);
    },
  },
};
</script>
